<template>
  <div class="ideas-block__section">
    <div
      class="ideas-block__section-header"
      :class="{'is-active': isShow}"
      @click.prevent="showSection"
    >
      <div class="ideas-block__section-title">
        <span>0{{ index }}</span>
        {{ title }}
      </div>
      <div class="ideas-block__section-description">
        {{ description }}
      </div>

      <div class="ideas-block__section-icon" />
    </div>

    <div v-if="isShow" class="ideas-block__subsection-wrapp">
      <Subsections
        v-for="(item, id) in subsections"
        v-show="item.files.length > 0"
        :key="id"
        :title="item.title"
        :files="item.files"
      />
    </div>
  </div>
</template>

<script>
  import Subsections from '@/components/shared/Subsections'
  export default {
    name: 'Section',

    components: { Subsections },

    props: {
      title: {
        type: String,
        default: ''
      },
      index: {
        type: Number
      },
      description: {
        type: String,
        default: ''
      },
      subsections: {
        type: Array,
        default: () => []
      }
    },

    data () {
      return {
        isShow: false
      }
    },

    computed: {

    },

    methods: {
      showSection () {
        this.isShow = !this.isShow
      }
    }

  }
</script>

<style lang="scss">
.ideas-block__section {
  border-bottom: 2px solid #DBDBDB;
  padding: 22px 0 26px;

  @include mobile {
    padding: 16px 0;
  }

  &:first-child {
    border-top: 2px solid #DBDBDB;
  }

    &:nth-child(2) .ideas-block__section-title {
      color: $c-orange;
      span{
        color: $c-orange;
      }
    }

    &:nth-child(3) .ideas-block__section-title {
      color: $c-yellow;
      span{
        color: $c-yellow;
      }
    }

    &-header {
      position: relative;
      cursor: pointer;

      &.is-active, {
        .ideas-block__section-icon::after {
          transform: rotate(180deg);
        }
      }
    }

  &-title {
    font-size: 30px;
    font-weight: 500;
    line-height: 1.34;
    color: $c-red;

    @include mobile {
      font-size: 18px;
    }

    span {
      margin-right: 88px;
      color: $c-red;
      font-size: 22px;
      font-weight: 700;

      @include tablet {
        margin-right: 30px;
      }

      @include mobile {
        font-size: 16px;
      }
    }
  }

  &-description {
    margin-top: 6px;
    font-size: 18px;
    line-height: 1.34;
    color: $c-medium-black;
    width: 100%;
    max-width: 668px;
    margin-left: 120px;

    @include tablet {
      margin-left: 60px;
      max-width: 620px;
    }

    @include mobile {
      margin-left: 50px;
      max-width: calc(100% - 50px);
      font-size: 14px;
      line-height: 18px;
    }
  }

  &-icon {
    position: absolute;
    right: 0;
    transform: translateY(-50%);
    top: 50%;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 2px solid #797979;

    &::before,
    &::after {
      content: '';
      position: absolute;
      width: 14px;
      height: 2px;
      background-color: #797979;
      left: 7px;
      top: 13px;
      transition: 0.2s;

      @include mobile {
        width: 10px;
        top: 9px;
        left: 5px;
      }
    }

    &::after {
      transform: rotate(90deg);
    }

    @include mobile {
      width: 24px;
      height: 24px;
      top: 15px;
    }
  }
}
</style>
